<template>
  <div class="p-v-sm">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="m-0">Red Diesel Monthly Totals</h3>
    </div>

    <!-- Loading Indicator -->
    <div v-show="loading" class="text-center my-5">
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!-- Month Navigation -->
    <div class="d-flex justify-content-between align-items-center mb-4" v-if="!loading">
      <button class="btn btn-primary" @click="previousMonth">
        <i class="material-icons">navigate_before</i> Previous Month
      </button>
      <h4>{{ formattedCurrentMonth }}</h4>
      <button class="btn btn-primary" @click="nextMonth" :disabled="isCurrentMonthToday">
        <i class="material-icons">navigate_next</i> Next Month
      </button>
    </div>

    <!-- Totals Cards -->
    <div class="row" v-if="!loading">
      <div class="col-md-6">
        <div class="card widget widget-stats-large">
          <div class="card-body">
            <div class="widget-stats-large-info">
              <div class="widget-stats-large-title">Total Customers</div>
              <div class="widget-stats-large-amount">
                {{ redDieselTotals.customerCount || 0 }}
              </div>
              <div class="widget-stats-large-info-text">Number of customers for {{ formattedCurrentMonth }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card widget widget-stats-large">
          <div class="card-body">
            <div class="widget-stats-large-info">
              <div class="widget-stats-large-title">Total Litres</div>
              <div class="widget-stats-large-amount">
                {{ redDieselTotals.totalLitres.toFixed(2) || 0 }}L
              </div>
              <div class="widget-stats-large-info-text">Total litres dispensed for {{ formattedCurrentMonth }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import siteService from "../../../../services/site.service";
import { DateTime } from "luxon";

export default {
  name: "RedDieselTotals",
  props: {
    site: Object,
  },
  data() {
    return {
      loading: false,
      redDieselTotals: {
        customerCount: 0,
        totalLitres: 0
      },
      currentMonth: DateTime.local().toFormat('yyyy-MM'),
    }
  },
  computed: {
    formattedCurrentMonth() {
      return DateTime.fromFormat(this.currentMonth, 'yyyy-MM').toFormat('MMMM yyyy');
    },
    isCurrentMonthToday() {
      const today = DateTime.local().toFormat('yyyy-MM');
      return this.currentMonth === today;
    }
  },
  mounted() {
    this.loadRedDieselTotals();
  },
  methods: {
    async loadRedDieselTotals() {
      this.loading = true;
      siteService
        .getRedDieselTotals(this.site.id, { date: this.currentMonth })
        .then((response) => {
          this.redDieselTotals = {
            customerCount: response.data.monthlyStats.customerCount || 0,
            totalLitres: response.data.monthlyStats.totalLitres || 0
          };
        })
        .catch((error) => {
          this.$error("Failed loading submissions", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    previousMonth() {
      const dt = DateTime.fromFormat(this.currentMonth, 'yyyy-MM');
      this.currentMonth = dt.minus({ months: 1 }).toFormat('yyyy-MM');
      this.loadRedDieselTotals();
    },
    nextMonth() {
      const dt = DateTime.fromFormat(this.currentMonth, 'yyyy-MM');
      const nextMonth = dt.plus({ months: 1 }).toFormat('yyyy-MM');
      
      const today = DateTime.local().toFormat('yyyy-MM');
      if (parseInt(nextMonth) <= parseInt(today)) {
        this.currentMonth = nextMonth;
        this.loadRedDieselTotals();
      }
    }
  }
}

</script>

<style scoped>
.widget-stats-large-amount {
  font-size: 3rem;
  font-weight: 700;
  color: #2269f5;
}

.widget-stats-large-title {
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.widget-stats-large-info-text {
  color: #6c757d;
  margin-top: 0.5rem;
}
.btn {
  margin-left: 4px;
  margin-right: 4px;
  margin-top: 4px;  
  margin-bottom: 4px;
  position: relative;
} 

</style>